import React, { useEffect, useMemo, useState } from "react";
import { RowFlex, Add } from "./style";
import Button from "../../../components/FormElement/Button";
import ProjectCard from "../../../components/Cards/CategoryCard";
import { PlusOutlined } from "@ant-design/icons";
import { useHideModal, useShowModal } from "../../../hooks";
import CustomPagination from "../../../components/FormElement/Pagination";
import Form from "./Form";
import DeleteModal from "../../../components/DeleteModal";
import { useShowAlert } from "../../../hooks/useAlerts";
import service from "../../../services/projectCategory";
import Spinner from "../../../components/Spinner/FullScreen";

function ProjectCategory() {
  const [loading, setLoading] = useState(false);
  const { hideModal } = useHideModal();
  const { showBlured } = useShowModal();
  const { error } = useShowAlert();

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);

  const pageQuery = useMemo(
    () => (pagination.page ? `page=${pagination.page}` : " "),
    [pagination.page]
  );
  const limitQuery = useMemo(
    () => (pagination.limit ? `&limit=${pagination.limit}` : ""),
    [pagination.limit]
  );
  const query = useMemo(
    () => `${pageQuery}${limitQuery}`,
    [pageQuery, limitQuery]
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await service.getAllPaginate(query);
      const finalResult = result.rows.map((item, idx) => ({
        ...item,
        index: pagination.page * pagination.limit - pagination.limit + idx + 1,
      }));
      setData(finalResult);
      setTotal(result.count);
    } catch (err) {
      console.log(err);
      error(
        "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [query]);

  const handleDel = (id) => {
    setLoading(true);
    service
      .delete(id)
      .then(() => {
        fetchData();
        hideModal();
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
    hideModal();
  };
  const handleDelete = (id) => {
    showBlured({
      title: "",
      maxWidth: "470px",
      height: "400px",
      withHeader: false,
      body: () => <DeleteModal onClick={() => handleDel(id)} />,
    });
  };
  const handleEdit = (id) => {
    showBlured({
      title: "Tahrirlash",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form state={id} refreshData={fetchData} />,
    });
  };

  const handleShowModal = () => {
    showBlured({
      title: "Loyiha kategoriyasi yarating",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form refreshData={fetchData} />,
    });
  };

  const handleChangePagination = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };

  if (loading) return <Spinner />;
  return (
    <div>
      <Add>
        <Button
          text="Qo'shish"
          icon={<PlusOutlined />}
          onClick={handleShowModal}
        />
      </Add>
      <RowFlex>
        {data.map((item) => (
          <div className="card" key={item.id}>
            <ProjectCard
              data={item}
              onDelete={() => handleDelete(item.id)}
              onEdit={() => handleEdit(item.id)}
            />
          </div>
        ))}
      </RowFlex>
      {total > 10 && (
        <CustomPagination
          align="end"
          total={total}
          onChange={handleChangePagination}
          defaultPageSize={pagination.limit}
          defaultCurrent={pagination.page}
        />
      )}
    </div>
  );
}

export default ProjectCategory;
